export function getPriceWithMarkup(ticketPrice, maxTicketPrice) {
    var is_self_paying = localStorage.getItem("is_self_paying");
    const maxPrice = parseFloat(maxTicketPrice);
    const price = parseFloat(ticketPrice);
    var margin = 0;
    if ((price < maxPrice) && is_self_paying == 0) {
        margin = 0.30;
    } else if (is_self_paying == 1) {
        margin = 0.05;
    }
    let finalPrice = price * (1 + margin);
    if (finalPrice > maxPrice && price < maxPrice) {
        finalPrice = maxPrice;
    }
    return parseFloat(finalPrice);
}
export function getTotalPriceWithMarkup(travelerPricings, maxTicketPrice) {
    var is_self_paying = localStorage.getItem("is_self_paying");
    var finalPrice = 0;
    travelerPricings.forEach(element => {
        const maxPrice = parseFloat(maxTicketPrice);
        const ticketPrice = parseFloat(element.price.total);
        var margin = 0;
        if ((ticketPrice < maxPrice) && is_self_paying == 0) {
            margin = 0.30;
        } else if (is_self_paying == 1) {
            margin = 0.05;
        }
        let price = ticketPrice * (1 + margin);
        if (price > maxPrice && ticketPrice < maxPrice) {
            price = maxPrice;
        }
        finalPrice += price;
    });
    return (finalPrice);
}